import React from "react";

import * as styles from "./button-dock.styled";

type ButtonDockProps = {
  isFixedOnMobile?: boolean;
  isCentered?: boolean;
  hasGradientOverlay?: boolean;
  children: React.ReactNode;
  isPrepackagePage?: boolean;
  isSingleButton?: boolean;
  isPrepackageOpaque?: boolean;
  withSpacers?: boolean;
};

export const ButtonDock = ({
  isFixedOnMobile,
  isCentered,
  hasGradientOverlay,
  isPrepackagePage,
  isSingleButton,
  isPrepackageOpaque,
  withSpacers = true,
  children,
}: ButtonDockProps) => {
  return (
    <>
      {withSpacers ? (
        <>
          {isFixedOnMobile ? (
            <div className="h-20 lg:hidden" aria-hidden="true" />
          ) : null}
          <div className="hidden h-16 lg:block" aria-hidden="true" />
        </>
      ) : null}
      <div
        className={styles.mobile(
          isFixedOnMobile,
          isCentered,
          hasGradientOverlay,
        )}
      >
        {children}
      </div>
      <div
        className={styles.wrapper(
          hasGradientOverlay,
          isPrepackagePage,
          isSingleButton,
          isPrepackageOpaque,
        )}
      >
        <div className={styles.innerWrapper}>{children}</div>
      </div>
    </>
  );
};
